import { render, staticRenderFns } from "./applications-list.vue?vue&type=template&id=589b74aa&scoped=true"
import script from "./applications-list.vue?vue&type=script&lang=js"
export * from "./applications-list.vue?vue&type=script&lang=js"
import style0 from "./applications-list.vue?vue&type=style&index=0&id=589b74aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589b74aa",
  null
  
)

export default component.exports